import Image from './Image.vue'

export default Image
